import { render, staticRenderFns } from "./office-modal.vue?vue&type=template&id=0b63ca72&"
import script from "./office-modal.vue?vue&type=script&lang=js&"
export * from "./office-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports